import { Injectable } from '@angular/core';
import { Router } from  "@angular/router";
import { auth } from  'firebase/app';
import { AngularFireAuth } from  "@angular/fire/auth";
import { User } from  'firebase';
import { AngularFirestore } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  user: User;
  userid: string;

  constructor(public  afAuth:  AngularFireAuth, public  router:  Router, 
    public firestore:AngularFirestore,) { 

    this.afAuth.authState.subscribe(user => {
      if (user){
        this.user = user;
        localStorage.setItem('user', JSON.stringify(this.user));
      } else {
        localStorage.setItem('user', null);
      }
    })
  }
  

  async login(email: string, password: string) {
    var result = await this.afAuth.auth.signInWithEmailAndPassword(email, password)
    this.router.navigate(['dashboard/products']);
  }
  get isLoggedIn(): boolean {
    const  user  =  JSON.parse(localStorage.getItem('user'));
    return  user  !==  null;
  }

  async logout(){
    console.log("working");
    
    await this.afAuth.auth.signOut();
    localStorage.removeItem('user');
    this.router.navigate(['dashboard']);
  }

  async register(email: string, password: string, userData: any) {
    //console.log('Service',userData);

    
    
    
    var result = await this.afAuth.auth.createUserWithEmailAndPassword(email, password)
    .then(async function(data){
      
     return data.user.uid as String;
    
      //Here if you want you can sign in the user
    }).catch(function(error) {
      console.log('Error',error);
        //Handle error
    });
    //this.sendEmailVerification();

    console.log(result as string);

    this.userid = result as string;

    console.log(this.userid);
    

    
}



}





